var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPerplexity = function SvgPerplexity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E1F1D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.663 1.691v13M5.24 5.715v-3.33l3.423 3.33M8.663 10.549 5.24 13.997V9.195l3.423-3.48M8.663 5.715l3.424-3.33v3.33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E1F1D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.24 10.656H3.81v-4.94h9.706v4.94h-1.43"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E1F1D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m8.663 5.715 3.424 3.48v4.802l-3.424-3.448"
  })));
};
export default SvgPerplexity;